var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0002 3.5C33.622 4.13335 35.1502 4.95359 36.5583 5.93424C42.2654 9.90878 46.0002 16.5183 46.0002 24.0002C46.0002 36.1505 36.1505 46.0002 24.0002 46.0002C16.5183 46.0002 9.90878 42.2654 5.93424 36.5583C4.95359 35.1502 4.13335 33.622 3.5 32.0002C3.5 32.0002 5.38129 32.6022 8.26807 32.7553C12.8225 32.9968 19.8797 32.1208 26.0002 26.0002C32.1208 19.8797 32.9968 12.8225 32.7553 8.26807C32.6022 5.38129 32.0002 3.5 32.0002 3.5ZM28.8287 28.8287C34.6575 22.9999 36.4388 16.3872 36.7405 11.2837C39.9922 14.542 42.0002 19.0387 42.0002 24.0002C42.0002 33.9414 33.9414 42.0002 24.0002 42.0002C19.0387 42.0002 14.542 39.9922 11.2837 36.7405C16.3872 36.4388 22.9999 34.6575 28.8287 28.8287ZM14.0002 6.82867L16.8287 9.65713L14.0003 12.4855L16.8287 15.314L19.6571 12.4856L22.4855 15.314L25.3139 12.4855L22.4855 9.65713L25.314 6.82867L22.4855 4.00025L19.6571 6.82871L16.8286 4.00024L14.0002 6.82867ZM12 26.0002C14.2091 26.0002 16 24.2094 16 22.0002C16 19.7911 14.2091 18.0002 12 18.0002C9.79086 18.0002 8 19.7911 8 22.0002C8 24.2094 9.79086 26.0002 12 26.0002Z",
    fill: "#5642A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.5dafe49562c5fb965977cd5955d2565c.svg";
export { ForwardRef as ReactComponent };